const name = 'teria';
export const INITIALIZE_REQUEST = `${name}/INITIALIZE_REQUEST`;
export const INITIALIZE_SUCCESS = `${name}/INITIALIZE_SUCCESS`;
export const INITIALIZE_FAILURE = `${name}/INITIALIZE_FAILURE`;

export const FETCH_PURCHASES_REQUEST = `${name}/FETCH_PURCHASES_REQUEST`;
export const FETCH_PURCHASES_SUCCESS = `${name}/FETCH_PURCHASES_SUCCESS`;
export const FETCH_PURCHASES_FAILURE = `${name}/FETCH_PURCHASES_FAILURE`;

export const SET_PERIOD = `${name}/SET_PERIOD`;



// WEBPACK FOOTER //
// ./src/sites/teria/constants.js